import { put, select, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';

import apiAuthCall from 'helpers/apiAuthCall';
import { throttle } from 'helpers/sagaEffects';
import {
    actions,
    fetchListSuccess
} from './duck';
import {
    offersEndpoint
} from './selectors';

export function* fetchOfferList(api, action) {
    const notificationId = 'getOfferList';
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(offersEndpoint)
            }
        );

        yield put(fetchListSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: notificationId,
            ...sagaError(err)
        }));
    }
}

export default function* offerSaga({ api }) {
    yield all([
        throttle(200, actions.FETCH_LIST, fetchOfferList, api),
    ]);
}



// WEBPACK FOOTER //
// ./src/services/offers/saga.js